/**
 * Función exportable para convertir texto a Smart Title Case
 * Solo capitaliza las palabras importantes (sustantivos, verbos, adjetivos)
 * Mantiene en minúsculas los artículos, preposiciones, conjunciones, etc.
 * La primera palabra siempre se capitaliza.
 *
 * Ejemplo: "REGION DE LOS LAGOS" → "Region de los Lagos"
 *
 * @param {string} text - El texto a convertir
 * @returns {string} - El texto en Smart Title Case
 */
export const toSmartTitleCase = text => {
	if (!text || typeof text !== 'string') return text;

	// Lista de palabras que NO se capitalizan (excepto si son la primera palabra)
	const lowercaseWords = new Set([
		// Artículos
		'el',
		'la',
		'los',
		'las',
		'un',
		'una',
		'unos',
		'unas',
		// Preposiciones
		'de',
		'del',
		'en',
		'con',
		'por',
		'para',
		'desde',
		'hasta',
		'sobre',
		'bajo',
		'ante',
		'tras',
		'mediante',
		'durante',
		'según',
		'sin',
		'hacia',
		'entre',
		'contra',
		'dentro',
		'fuera',
		'encima',
		'debajo',
		'delante',
		'detrás',
		'alrededor',
		'cerca',
		'lejos',
		'junto',
		'frente',
		'través',
		// Conjunciones
		'y',
		'e',
		'o',
		'u',
		'que',
		'si',
		'pero',
		'mas',
		'sino',
		'aunque',
		'porque',
		'como',
		'cuando',
		'donde',
		'mientras',
		'pues',
		'ni',
		'tanto',
		// Pronombres relativos y otros
		'quien',
		'quienes',
		'cual',
		'cuales',
		'cuyo',
		'cuya',
		'cuyos',
		'cuyas',
		// Otras palabras comunes que no se capitalizan
		'a',
		'al',
		'da',
		'das',
		'do',
		'dos',
		'na',
		'nas',
		'no',
		'nos',
	]);

	// Dividir el texto en palabras, preservando espacios
	const words = text.toLowerCase().split(/(\s+)/);

	return words
		.map((word, index) => {
			// Si es un espacio, devolverlo tal como está
			if (/^\s+$/.test(word)) {
				return word;
			}

			// Obtener solo la parte alfabética de la palabra (sin puntuación)
			const cleanWord = word.replace(/[^\w]/g, '');

			// Si es la primera palabra real o no está en la lista de palabras menores, capitalizar
			const isFirstRealWord =
				index === 0 || words.slice(0, index).every(w => /^\s+$/.test(w));

			if (isFirstRealWord || !lowercaseWords.has(cleanWord)) {
				return word.charAt(0).toUpperCase() + word.slice(1);
			}

			// Si es una palabra menor, mantener en minúsculas
			return word;
		})
		.join('');
};
